import { useCallback } from 'react';
import { useChatContext } from '../context/use-chat-context';

export function usePlaygroundCtaInterceptor() {
  const { isPlayground, onPlaygroundCtaClick } = useChatContext();

  const interceptCtaClick = useCallback(
    (url: string | undefined): boolean => {
      if (!isPlayground || !onPlaygroundCtaClick || !url) return false;
      onPlaygroundCtaClick(url);
      return true;
    },
    [isPlayground, onPlaygroundCtaClick]
  );

  return { interceptCtaClick };
}
